import React from "react";
import {Container, Row, Col } from "reactstrap";
// import Afip from "../components/Afip/Afip";
import {Comunicate} from "../components/Comunicate/Comunicate";
import { Redes } from "../components/RedesSociales/Redes"

const DefaultLayout = ({children}) => {

    return (
      <>
        <Container>
          <Row>
            <Col md={6}>
              <div className="App">
                {children}
              </div>
              <Comunicate />
            </Col>
          </Row>
        </Container>
        <Redes />
      </>
    );
}

export default DefaultLayout;
